export const carouselInicio = [
    {
        //"imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png"
        "imagen" : "/assets/imgs/DSC05666_1.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC00489.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC04244.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC03585.JPG"
    },
]

export const carouselCepci = [
    {
        "imagen" : "/assets/imgs/DSC05666_1.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC00489.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC04244.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC03585.JPG"
    }
]